import { render, staticRenderFns } from "./UserPersonalInfo.vue?vue&type=template&id=c28704a6&scoped=true"
import script from "./UserPersonalInfo.vue?vue&type=script&lang=js"
export * from "./UserPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./UserPersonalInfo.vue?vue&type=style&index=0&id=c28704a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28704a6",
  null
  
)

export default component.exports